import { atom } from 'jotai'

const showLogoutDialogAtom = atom<boolean>(false)
const isAuthenticatedAtom = atom<boolean>(
  localStorage.getItem('isAuthenticated') === 'true' || false,
)
const isLoadingAuthStateAtom = atom<boolean>(false)

export { showLogoutDialogAtom, isAuthenticatedAtom, isLoadingAuthStateAtom }

isAuthenticatedAtom.debugLabel = 'isAuthenticatedAtom'
showLogoutDialogAtom.debugLabel = 'showLogoutDialogAtom'
isLoadingAuthStateAtom.debugLabel = 'isLoadingAuthStateAtom'
